import React, { useMemo, useState } from "react";
import { FaMagnifyingGlass } from "react-icons/fa6";
import styles from "../styles/platos.module.css";

export default function ScrollMultiSelect({
    options,
    value = [],
    onChange,
    placeholder = "Buscar…",
    height = 160,
}) {
    const [q, setQ] = useState("");
    const selectedSet = useMemo(() => new Set(value), [value]);

    const filtered = useMemo(() => {
        const t = q.trim().toLowerCase();
        if (!t) return options;
        return options.filter((o) => String(o.label).toLowerCase().includes(t));
    }, [options, q]);

    const toggle = (v) => {
        const next = selectedSet.has(v) ? value.filter((x) => x !== v) : [...value, v];
        onChange?.(next);
    };

    const selectAll = () => onChange?.(filtered.map((o) => o.value));
    const clearAll = () => onChange?.([]);

    return (
        <div className={styles.sms}>
            <input
                className={styles["sms-search"]}
                placeholder={placeholder}
                value={q}
                onChange={(e) => setQ(e.target.value)}
                aria-label="Buscar"
            />

            <div className={styles["sms-header"]}>
                <div className={styles["sms-actions"]}>
                    <button type="button" className={`${styles.btn} ${styles.ghost}`} onClick={selectAll}>
                        Todo
                    </button>
                    <button type="button" className={`${styles.btn} ${styles.ghost}`} onClick={clearAll}>
                        Ninguno
                    </button>
                </div>
            </div>

            <div
                className={styles["sms-box"]}
                style={{ maxHeight: height, overflowY: "auto" }}
                role="listbox"
                aria-multiselectable="true"
            >
                {filtered.length === 0 ? (
                    <div className={styles["sms-empty"]}>
                        <FaMagnifyingGlass style={{ fontSize: "30px" }} />
                    </div>
                ) : (
                    filtered.map((o) => {
                        const sel = selectedSet.has(o.value);
                        return (
                            <button
                                key={o.value}
                                type="button"
                                className={`${styles["sms-row"]} ${sel ? styles.selected : ""}`}
                                onClick={() => toggle(o.value)}
                                role="option"
                                aria-selected={sel}
                                title={o.label}
                            >
                                <input type="checkbox" readOnly tabIndex={-1} checked={sel} />
                                <span className={styles["sms-label"]}>{o.label}</span>
                            </button>
                        );
                    })
                )}
            </div>
        </div>
    );
}
